import {
  border,
  BorderProps,
  color,
  ColorProps,
  compose,
  css,
  layout,
  LayoutProps,
  ResponsiveValue,
  space,
  SpaceProps,
  variant,
} from '@wrisk/styled-system'
import styled from 'styled-components'

import { withDefaultProps } from '../../defaultProps'

export type NavigationProperty = 'default'

export interface NavigationProps
  extends LayoutProps,
    SpaceProps,
    ColorProps,
    BorderProps {
  variant?: ResponsiveValue<NavigationProperty>
}

const defaultProps = withDefaultProps<NavigationProps>({
  variant: 'default',
})

export const Navigation = styled.nav
  .attrs<NavigationProps>(defaultProps)
  .attrs({ role: 'navigation' })(
  css({
    width: '100%',
    position: 'relative',
    bg: 'surfaceNavigation',
    borderWidth: 0,
    borderStyle: 'solid',
    borderColor: 'border',
  }),
  variant({
    scale: 'Navigation',
    variants: {
      default: {},
    },
  }),
  compose(layout, space, color, border),
)
